import { useState, useRef } from 'react';

export const useVerificationCode = (length = 5) => {
  const [code, setCode] = useState(new Array(length).fill(''));
  const inputsRef = useRef([]);

  const handleChange = (index, value) => {
    if (!/^\d*$/.test(value)) return;
    
    const newCode = [...code];
    newCode[index] = value;
    setCode(newCode);

    if (value && index < length - 1) {
      inputsRef.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === 'Backspace' && !code[index] && index > 0) {
      inputsRef.current[index - 1]?.focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const paste = e.clipboardData.getData('text');
    const regex = new RegExp(`^\\d{${length}}$`);
    
    if (!regex.test(paste)) return;

    const newCode = paste.split('');
    setCode(newCode);
    inputsRef.current[length - 1]?.focus();
  };

  const clearCode = () => {
    setCode(new Array(length).fill(''));
    inputsRef.current[0]?.focus();
  };

  const getCodeValue = () => code.join('');
  const isCodeComplete = code.every(digit => digit !== '');

  return {
    code,
    setCode,
    inputsRef,
    handleChange,
    handleKeyDown,
    handlePaste,
    clearCode,
    getCodeValue,
    isCodeComplete,
  };
};

